export const visit = (vm, at) => {
vm(require("SharedI18nStrings/lang/languageNames/ja.lyaml"));
at({ "ja": { "videoData": { "time": { "abbreviations": { "hour": "\u6642\u9593", "minute": "\u5206", "second": "\u79D2" } } } } });
};